import { createContext } from 'react';
import type { Messages } from './Messages';

export const MessagesContext = createContext<Messages>({
  messages: [],
  dismiss: () => {
    console.log('dismiss');
  },
  showSuccess: (text) => {
    console.log(text);
    return 0;
  },
  showInfo: (text) => {
    console.log(text);
    return 0;
  },
  showWarning: (text) => {
    console.warn(text);
    return 0;
  },
  showError: (text) => {
    console.error(text);
    return 0;
  },
});
MessagesContext.displayName = 'MessagesContext';
